{
  "layout": {
    "title": "Market",
    "intro": "Buy, sell, bid, and trade characters for Anima.",
    "tabs": "Market sections",
    "sales": "Listings",
    "auctions": "Auctions",
    "myListings": "My listings",
    "myAuctions": "My auctions",
    "history": "History",
    "trades": "Trades"
  },
  "openCollection": "Open my collection",
  "sorts": {
    "recent": "Newest",
    "price_asc": "Price: low to high",
    "price_desc": "Price: high to low",
    "auction_ending": "Ending soonest",
    "auction_price": "Current price: low to high",
    "attack_desc": "Attack (high → low)",
    "attack_asc": "Attack (low → high)",
    "defense_desc": "Defense (high → low)",
    "defense_asc": "Defense (low → high)",
    "auction_attack_desc": "Attack (high → low)",
    "auction_attack_asc": "Attack (low → high)",
    "auction_defense_desc": "Defense (high → low)",
    "auction_defense_asc": "Defense (low → high)"
  },
  "listingStatus": {
    "active": "For sale",
    "sold": "Sold",
    "cancelled": "Withdrawn",
    "expired": "Expired"
  },
  "filters": {
    "button": "Filters",
    "title": "Refine the market",
    "reset": "Reset",
    "results": "Show results",
    "search": "Search for a character or a title",
    "rarity": "Filter by rarity",
    "all": "All rarities",
    "sort": "Sort"
  },
  "empty": {
    "listings": "No listings",
    "listingsRarity": "No active listings in this rarity.",
    "listingsSearch": "No listing matches this search.",
    "listingsHint": "List a card from its page in your collection.",
    "auctions": "No live auctions",
    "auctionsHint": "Start an auction from a card’s page in your collection.",
    "auctionsSearch": "No auction matches this search.",
    "auctionsRarity": "No live auctions in this rarity.",
    "myAuctions": "No auctions",
    "history": "No transactions",
    "historyHint": "Your completed purchases, sales, and trades will show up here."
  },
  "buy": {
    "title": "Buy {{name}}",
    "quoteBefore": "“",
    "quoteAfter": "”",
    "seller": "Seller",
    "level": "Card level",
    "price": "Price",
    "after": "Balance after purchase",
    "duplicate": "If you already own this character, the card you receive is converted into fragments.",
    "short": "You’re short {{amount}} Anima.",
    "success": "Purchase complete",
    "failed": "Couldn’t buy",
    "action": "Buy"
  },
  "bids": {
    "none": "No bids",
    "count_one": "{{count}} bid",
    "count_other": "{{count}} bids"
  },
  "mine": {
    "withdrawn": "Listing withdrawn",
    "withdrawFailed": "Couldn’t withdraw",
    "withdraw": "Withdraw"
  },
  "history": {
    "player": "a player",
    "listingSale": "Sale to {{peer}}",
    "auctionSale": "Auction won by {{peer}}",
    "listingBuy": "Purchase from {{peer}}",
    "auctionBuy": "Auction won against {{peer}}",
    "trade": "Trade with {{peer}}",
    "characters": "Characters involved",
    "level": "Level {{level}}",
    "given": "Given",
    "received": "Received",
    "noAnima": "No Anima"
  },
  "myAuctions": {
    "cancelled": "Auction cancelled",
    "cancelFailed": "Couldn’t cancel"
  },
  "sell": {
    "title": "Sell {{name}}",
    "kind": "Sale type",
    "fixed": "Fixed price",
    "auction": "Auction",
    "system": "System",
    "price": "Price",
    "start": "Starting price",
    "range": "Between {{min}} and {{max}} Anima.",
    "buyout": "Buyout (optional)",
    "none": "None",
    "buyoutHint": "Must be higher than the starting bid.",
    "duration": "Duration",
    "hours": "{{hours}}h",
    "value": "Value (lv. {{level}})",
    "buyback": "Buyback ({{percent}}%)",
    "jackpot": "Jackpot ({{percent}}% of the buyback)",
    "receive": "You receive",
    "fee": "Fee ({{percent}}%)",
    "net": "You’ll receive",
    "netLeast": "You’ll receive at least",
    "systemHint": "The system buys the card back at {{percent}}% of its value. You don’t set the price. {{pot}}% of that amount goes to the Anima Harvest jackpot.",
    "feeHint": "These fees go to the Anima Harvest jackpot. The buyer receives the card at level {{level}}.",
    "fragments": "Your {{amount}} fragments are set aside and come back if you obtain this character again.",
    "tooCheap": "This card isn’t worth enough to sell to the system.",
    "locked": "This card is already listed or in a trade.",
    "toSystem": "Sell to the system",
    "list": "List for sale",
    "launch": "Start the auction",
    "listed": "Listing created",
    "launched": "Auction started",
    "listFailed": "Couldn’t list this card",
    "boughtTitle": "Card sold to the system",
    "bought": "{{name}} · {{amount}} Anima"
  },
  "auction": {
    "back": "Auctions",
    "byBefore": "Listed by",
    "cardLevel": "card level {{level}}",
    "endsIn": "Ends in",
    "ended": "Ended",
    "closed": {
      "sold": "Sold",
      "unsold": "Ended with no buyer",
      "cancelled": "Cancelled"
    },
    "best": "Highest bid",
    "start": "Starting price",
    "min": "Minimum bid",
    "buyout": "Buyout",
    "leader": "Highest bidder",
    "nobody": "No one",
    "seller": "This is your sale: you can’t bid on it.",
    "yourBid": "Your bid",
    "leading": "You’re in the lead. You can bid again if someone passes you.",
    "minHint": "Between {{min}} and {{max}} Anima, held until someone outbids you.",
    "bid": "Place bid",
    "bidOk": "Bid placed",
    "bidNo": "Bid rejected",
    "buyoutOk": "Buyout complete",
    "buyoutNo": "Couldn’t buy out",
    "buy": "Buy",
    "recent": "Latest bids",
    "none": "No bids yet.",
    "buyoutTag": " · buyout"
  },
  "trades": {
    "aria": "Trade inbox",
    "incoming": "Received",
    "outgoing": "Sent",
    "history": "History",
    "emptyIncoming": "No offers received",
    "emptyOutgoing": "No offers sent",
    "emptyHistory": "No finished trades",
    "emptyHint": "To offer a trade, open a player’s profile.",
    "pending": "In progress",
    "completed": "Completed",
    "declined": "Declined",
    "cancelled": "Cancelled",
    "expired": "Expired"
  },
  "cards_one": "{{count}} card",
  "cards_other": "{{count}} cards",
  "animaAmount": "{{amount}} Anima",
  "nothing": "nothing",
  "row": {
    "summary": "You give {{give}} · you receive {{receive}}",
    "balanced": "even",
    "gain": "+{{amount}} Anima in value",
    "loss": "−{{amount}} Anima in value",
    "obtained": "Owned",
    "notObtained": "Not owned",
    "turn": "Your turn",
    "waiting": "Waiting"
  },
  "side": {
    "youGive": "You give",
    "youReceive": "You receive",
    "nothing": "Nothing",
    "cards": "Cards",
    "anima": "Anima",
    "total": "Total"
  },
  "value": {
    "even": "This trade is even at reference value.",
    "gain": "You gain about {{amount}} Anima in value.",
    "loss": "You lose about {{amount}} Anima in value."
  },
  "detail": {
    "back": "Trades",
    "title": "Trade with @{{username}}",
    "closed": "{{status}} on {{date}}",
    "yourTurn": "Your turn to reply · expires in {{time}}",
    "waiting": "Waiting on @{{username}} · expires in {{time}}",
    "fee": "A {{percent}}% fee is kept on the Anima:",
    "done": "Trade completed",
    "confirmFailed": "Couldn’t confirm",
    "counter": "Counter",
    "declined": "Trade declined",
    "declineFailed": "Couldn’t decline",
    "decline": "Decline",
    "cancelled": "Trade cancelled",
    "cancelFailed": "Couldn’t cancel",
    "cancel": "Cancel the offer",
    "accept": "Accept the trade"
  },
  "youGive": "You give",
  "youReceive": "You receive",
  "picker": {
    "search": "Search",
    "add": "Add a card…",
    "filter": "Filter cards",
    "searchToAdd": "Search for a card to add it to the trade.",
    "noResults": "No results for this search.",
    "total": "Cards total",
    "sorts": {
      "recent": "Recently obtained",
      "popularity": "Popularity",
      "nametag": "Tag",
      "rarity": "Rarity",
      "fragments": "Fragments",
      "name": "Name",
      "attack_desc": "Attack (high → low)",
      "attack_asc": "Attack (low → high)",
      "defense_desc": "Defense (high → low)",
      "defense_asc": "Defense (low → high)"
    }
  },
  "builder": {
    "trade": "Trade",
    "counter": "Counter-offer",
    "offer": "Offer a trade",
    "intro": "With @{{username}}. You can offer up to {{max}} cards. Anima can come from only one side, and a {{fee}}% fee on it goes to the Anima Harvest jackpot.",
    "cardLimit": "You can select up to {{max}} cards on this side.",
    "playerLimits": "Your limits: {{mine}} cards and {{mineAnima}} Anima. Partner limits: {{theirs}} cards and {{theirsAnima}} Anima.",
    "limitsExceeded": "This offer exceeds one player's current limits. Reduce the cards or Anima on that side.",
    "invalidAnima": "Anima must be a non-negative whole number, without decimals.",
    "ask": "You ask for",
    "emptyMine": "No cards available: cards listed for sale or in a trade are locked.",
    "animaGive": "Anima offered",
    "emptyTheirs": "@{{username}} has no cards available.",
    "animaAsk": "Anima requested",
    "gap": "Difference",
    "even": "Even",
    "note": "Message (optional)",
    "notePlaceholder": "A note to go with your offer",
    "oneSide": "Anima can come from only one side.",
    "sendCounter": "Send counter-offer",
    "send": "Offer the trade",
    "sentCounter": "Counter-offer sent",
    "sent": "Offer sent",
    "sendFailed": "Couldn’t send"
  }
}
